/**
 * @generated SignedSource<<af8a9f3a0285989a002235ca504017c2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type summaryCell_softwareCodePage$data = {
  readonly author: {
    readonly name: string;
    readonly picture: AGG$URL;
  } | null | undefined;
  readonly destinationBranch: {
    readonly name: string | null | undefined;
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly pullRequestInternalId: string | null | undefined;
  readonly repositoryName: string | null | undefined;
  readonly repositoryUrl: string | null | undefined;
  readonly title: string;
  readonly url: string | null | undefined;
  readonly " $fragmentType": "summaryCell_softwareCodePage";
};
export type summaryCell_softwareCodePage$key = {
  readonly " $data"?: summaryCell_softwareCodePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"summaryCell_softwareCodePage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "url"
},
v1 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "summaryCell_softwareCodePage",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "title"
      },
      "action": "THROW",
      "path": "title"
    },
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "picture"
        }
      ]
    },
    {
      "concreteType": "DevOpsBranchInfo",
      "kind": "LinkedField",
      "name": "destinationBranch",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v0/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "pullRequestInternalId"
    },
    {
      "kind": "ScalarField",
      "name": "repositoryName"
    },
    {
      "kind": "ScalarField",
      "name": "repositoryUrl"
    }
  ],
  "type": "DevOpsPullRequestDetails"
};
})();

(node as any).hash = "b9893f1621f2f57c99d54c5751e4ac33";

export default node;
